import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import SuperAdminUnitsPageLayout from '../../../layout/SuperAdminUnitsPageLayout';
import EditorsList from '../../../components/EditorsList';
const EditorsPage = () => {
    const { t } = useTranslation();
    return (_jsx(SuperAdminUnitsPageLayout, { title: t('admin.editors'), unit: 'editor', children: _jsx(EditorsList, { role: 'admin' }) }));
};
export default EditorsPage;
